import React, { createContext, useState, useContext, useEffect } from "react";
import { useParams } from "react-router";
import { useApiClient } from "../../../shared/customHooks";
import { PageHeader } from "../../header/PageHeader";

// Create a Context
const ProviderContext = createContext<IProviderContext>({
  id: "",
  provider: {},
  providerBase: {},
  rehydrate: async () => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setProvider: (provider: any) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setHeaderText: (headerText: IHeadetText) => {},
});

// Create a provider component
export const ProviderComponentContext = ({ children }: any) => {
  const [provider, setProvider] = useState<any>({});
  const { fetchData } = useApiClient("Provider");
  const [loaded, setLoaded] = useState(false);
  const { id } = useParams<{ id: string }>();

  const [headerText, setHeaderText] = useState<IHeadetText>({
    value: "Edit Provider",
    icon: "view-app-icon icon-spec mr-3 mt-0",
  });

  useEffect(() => {
    getProviderData(id ?? "");
  }, [id]);

  function rehydrate(): Promise<void | never> {
    return getProviderData(id ?? "");
  }

  function getProviderData(id: string): Promise<void | never> {
    return fetchData(id).then((res) => {
      setProvider(res.data);
      setLoaded(true);
    });
  }

  return (
    <ProviderContext.Provider
      value={{
        id: id ?? "",
        provider,
        providerBase: provider.providerBase,
        rehydrate,
        setProvider,
        setHeaderText,
      }}>
      <PageHeader headerText={[headerText]} icon={"icon"}></PageHeader>
      {loaded && children}
    </ProviderContext.Provider>
  );
};

interface IProviderContext {
  id: string;
  provider: any;
  providerBase: any;
  rehydrate: () => Promise<void | never>;
  setProvider: (provider: any) => void;
  setHeaderText: (headerText: IHeadetText) => void;
}

interface IHeadetText {
  value: string;
  icon: string;
  class?: string;
}
// Custom hook for using the context
export const useProviderContext = (): IProviderContext => useContext(ProviderContext);
